// extracted by css-extract-rspack-plugin
export default {"cls1":"SocialActionsMenu-cls1_rZu","cls2":"SocialActionsMenu-cls2_345 SocialActionsMenu-cls1_rZu"};